// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__ktCaK","summary":"CartItem_summary__fDiDM","price":"CartItem_price__xfFjH","amount":"CartItem_amount__u1h34","actions":"CartItem_actions__ejjX+"};